<div class="modal-header border-0 ps-5 pe-5">
  <div class="font-xl fw-bold text-center uppercase"
       [translate]="'modal.faq.header'">
    How can we help you?
  </div>

</div>
<div class="modal-body">
  <div>
    <label class="fw-bold font-xl"
           [translate]="'modal.faq.lookingForCake'">
      Bestille kake?
    </label>
    <ui-location-search-bar
      [bordless]="false"
      [showLoading]="true"
      (onLocationFound)="onLocationFound.emit($event)">
    </ui-location-search-bar>
  </div>

  <div class="mt-4" *ngIf="faqs && faqs.length">
    <label class="fw-bold font-xl"
           [translate]="'modal.faq.faqListTitle'">Type something</label>

    <div class="custom-accordion">
      <div ngbAccordion [closeOthers]="true">
        <div ngbAccordionItem *ngFor="let faq of faqs; let i=index;" [id]="'faq-' + i">
          <h2 ngbAccordionHeader>
            <button ngbAccordionButton>
              <span class="fw-normal">{{ faq.question }}</span>
              <i class="icon-chevron-down"></i>
              <i class="icon-chevron-up"></i>
            </button>
          </h2>

          <div ngbAccordionCollapse>
            <div ngbAccordionBody>
              <ng-template>
                <div [innerHTML]="faq.answer"></div>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>

  <div class="mt-4 mb-4">
    <label class="d-block fw-bold font-xl"
           [translate]="'modal.faq.otherQuestion'">Andre spørsmål?</label>
    <button class="btn btn-primary"
            (click)="onFormChange.emit()"
            [translate]="'modal.faq.contactUs'">Ta kontakt med oss
    </button>
  </div>
</div>
